import { SpriteTypes, spriteCategory } from '../types/sprite-types'
import { uuid } from '@/libs/src/utils/tools'
const options = {
    visible: true,
    width: 100,
    height: 100,
    name: "image",
    lineWidth: 0, radio: true, imageRatio: true,isBottom:true,disableAnchor:true,
}

export default [
    {
        id: uuid(),
        name: "背景1",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg1.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg1.png",
            ...options
        },
    }, {
        id:uuid(),
        name: "背景2",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg2.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg2.png",
            ...options
        },
    }, {
        id:uuid(),
        name: "背景3",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg3.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg3.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "背景4",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg4.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg4.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "背景5",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg5.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg5.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "背景6",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg6.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg6.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "背景7",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg7.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg7.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "背景8",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg8.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg8.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "开关（on）",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg9.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg9.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "开关（off）",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg10.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg10.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "背景11",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg11.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg11.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "背景12",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg12.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg12.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "背景13",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg13.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg13.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "背景14",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg14.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg14.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "背景15",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg15.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg15.png",
            ...options
        },
    },
    {
        id: uuid(),
        name: "背景16",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg16.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg16.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "背景17",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg17.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg17.png",
            ...options
        },
    }, {
        id:uuid(),
        name: "背景18",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg18.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg18.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "背景19",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg19.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg19.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "背景20",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg20.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg20.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "背景21",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg21.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg21.png",
            ...options
        },
    }, {
        id: uuid(),
        name: "背景22",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg22.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg22.png",
            ...options
        },
    }, {
        id:uuid(),
        name: "背景23",
        type: SpriteTypes.sprite,
        image: "images/menubg/bg23.png",
        categrory: spriteCategory.bg,
        data: {
            image: "images/menubg/bg23.png",
            ...options
        },
    }
]